import { cloneDeep } from 'lodash';
import propagationManager from './propagation-manager';

export default {
    pushVirtualPage : (stepName, additionalPayload = {}, saveToGlobal, otherData) => {
        window.globalEventData = {};
        let eventName = 'VP ' + stepName;
        let stepObj = {
            event : eventName
        };

        if (typeof otherData !== 'string'){
            stepObj = Object.assign({}, stepObj, otherData);
        }

        if(saveToGlobal) globalEventHandler(Object.assign({}, stepObj, additionalPayload));
        setTimeout(() => {
            try{
                pushToDataLayer(stepObj);
            } catch(e){

            }
        }, 250);
    },
    pushCustomEvent : (eventName, additionalPayload = {}, saveToGlobal = false) => {
        window.globalEventData = {};
        let eventObj = genereteEventObj(eventName, additionalPayload.selection);
        if(additionalPayload) eventObj = Object.assign({}, eventObj, additionalPayload);
        if(saveToGlobal) globalEventHandler(eventObj);
        let t = saveToGlobal ? genereteEventObj(eventName, additionalPayload.selection) : eventObj;
        pushToDataLayer(t);
    },
    pushZipCodeEvent : (marketName) => {
        let obj = {
            event: "Zip Code Validation",
            market: marketName
        };
        pushToDataLayer(obj);
    },
    pushMarketEvent : (eventName, payload) => {
        let obj = {
            event: eventName,
            'zip code': payload.zipcode
        };
        if (payload.market) {
            obj.market = payload.market;
        }
        pushToDataLayer(obj);
    },
    pushInputEvent : (eventName, additionalPayload, saveToGlobal) => {
        window.globalEventData = {};
        let eventObj = Object.assign({}, {event: 'CE ' + eventName}, additionalPayload);
        if (saveToGlobal) globalEventHandler(eventObj);
        pushToDataLayer(eventObj);
    },
	addToDataLayer: (payload) => {
		pushToDataLayer(payload);
	}

}

function globalEventHandler(eventObj){
    let temp = cloneDeep(eventObj);
    delete temp['event'];
    delete temp['flow step'];
    window.globalEventData = temp;
}

const pushToDataLayer = (payload) => {
	try {
		window.dataLayer.push(payload);
	} catch (error) {
		
	}

	try {
		if (propagationManager.inited) {
			propagationManager.propegateEvent(payload);
		}
	} catch (error) {
		
	}
}


function genereteEventObj(eventName, selection){
    return {
        event : 'Flow Selection',
        'debug flow selection step': eventName,
        'debug flow selection': selection
    }
}
